import { useState } from 'react';
import { Link } from 'react-router-dom';
import { TERMS_CONDITIONS_LINK, useGetContractor } from 'entities/profile';
import { pageRoutes } from 'shared/routes';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { getCurrentYear } from 'shared/lib/format';

import { phoneBlockIsTemporaryDisabled } from './ContractorLayoutContent';
import { ContractorMenuLink } from './ContractorMenuLink';
import { LayoutMenu } from './LayoutMenu';

export function ContractorLayoutMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const user = useGetContractor().data?.data;

  return (
    <LayoutMenu
      isMenuOpen={isMenuOpen}
      setIsMenuOpen={setIsMenuOpen}
      logoClassName="bg-[url('/assets/menu/contractor/logo.svg')]"
      smallLogoClassName="bg-[url('/assets/menu/contractor/logo-small.svg')]"
      className="border-r border-slate-100 bg-white"
    >
      <div className="flex grow flex-col justify-between">
        <div className="mt-29">
          <ContractorMenuLink
            iconName="campaign"
            title="Campaigns"
            href={pageRoutes.app.campaigns}
            isSmallSize={!isMenuOpen}
          />
          {(user?.hasLeadsCampaigns || user?.hasApptsCampaigns) && (
            <ContractorMenuLink
              iconName="group"
              title="Leads"
              href={pageRoutes.app.leads}
              isSmallSize={!isMenuOpen}
            />
          )}
          {user?.hasApptsCampaigns && (
            <ContractorMenuLink
              iconName="event_available"
              title="Call Center Leads"
              href={pageRoutes.app.appointments}
              isSmallSize={!isMenuOpen}
            />
          )}
          {user?.hasSalesCampaigns && (
            <ContractorMenuLink
              iconName="paid"
              title="Sales"
              href={pageRoutes.app.sales}
              isSmallSize={!isMenuOpen}
            />
          )}
          <ContractorMenuLink
            iconName="credit_card"
            title="Billing"
            href={pageRoutes.app.billing}
            isSmallSize={!isMenuOpen}
          />
          <ContractorMenuLink
            iconName="insert_chart"
            title="Reports"
            href={pageRoutes.app.reports}
            isSmallSize={!isMenuOpen}
          />
          <ContractorMenuLink
            iconName="account_circle"
            title="My account"
            href={pageRoutes.app.myAccount}
            isSmallSize={!isMenuOpen}
          />
        </div>
        <div className="w-full">
          {isMenuOpen && (
            <div className="pb-3 pt-6">
              {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
              {!phoneBlockIsTemporaryDisabled && (
                <div className="rounded-md border border-slate-100 px-4 py-[14px]">
                  <div className="mb-1 text-xs font-medium">Need help? Call us:</div>
                  <a
                    className="text-lg font-semibold"
                    href="tel:888-219-1908"
                  >
                    (888) 219-1908
                  </a>
                </div>
              )}
              <div className="ml-4 flex w-[184px]  gap-2 border-b border-slate-100 pb-4 text-xs text-slate-500">
                <Link
                  to={pageRoutes.app.faq.split(':')[0]}
                  className="flex items-center gap-2"
                >
                  <MaterialIcon className="h-[24px] w-[24px]">help_outlined</MaterialIcon>
                  <span className="font-medium">FAQs</span>
                </Link>
              </div>
              <div className="my-8 ml-4 flex w-[184px] flex-wrap gap-2 whitespace-nowrap text-xs text-slate-500">
                <a
                  target="_blank"
                  href="https://www.homebuddy.com/privacy-policy"
                  rel="noreferrer"
                  className="block"
                >
                  Privacy Policy
                </a>
                <a
                  target="_blank"
                  href="https://www.homebuddy.com/terms-of-use"
                  rel="noreferrer"
                  className="block"
                >
                  Terms of Use
                </a>
                <a
                  target="_blank"
                  href={TERMS_CONDITIONS_LINK}
                  rel="noreferrer"
                  className="block"
                >
                  Terms & Conditions
                </a>
              </div>
              <div className="whitespace-nowrap px-4 text-xs text-slate-500">© {getCurrentYear()} HomeBuddy.</div>
            </div>
          )}
          {!isMenuOpen && (
            <div className="ml-[-2px] w-[44px] whitespace-nowrap pb-3 pt-13 text-xs font-medium text-slate-500">
              © {getCurrentYear()}
            </div>
          )}
        </div>
      </div>
    </LayoutMenu>
  );
}
